module.exports = __webpack_public_path__ + "img/Logo.93db116a.webp";